import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import io from "socket.io-client";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

class AddMatrimony extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imageInput: [], // Store selected files
            currentImageUrls: [], // Store URLs for image previews
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
            errors: [],
            textInput: "",
            refCode: "",
            userName: "",
            fullName: "",
            fullName: "",
            emailInput: "",
            state: "",
            city: "",
            expectation: "",
            height: "",
            pinCode: "",
            bloodGroup: "",
            nativeOf: "",
            district: "",
            kulName: "",
            caste: "",
            perAnnum: "",
            dateInput: '',
            subcaste: "",
            gotra: "",
            education: "",
            areaInput: "",
            about: "",
            firmName: "",
            firmAddress: "",
            martitalStatus: "",
            profession: "",
            bodyColor: "",
            mobileNo: "",
            fathersContact: "",
            manglikCheck: "",
            manglik: true,
            amaglik: false,
            website: "",
            category: "",
            categoryData: [],
            images: [],
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
            errors: [],
          
            submissionStatus: null,
            currentImageUrl: null,
            submeet: false,
        };
        this.handlegenderChange = this.handlegenderChange.bind(this);

        this.handlemanglikChange = this.handlemanglikChange.bind(this);
        this.socket = io('https://samaj.aasmo.in/');
    }

    componentDidMount() {
        this.socket.on('newJobNotification', (notification) => {
            alert(notification.message);
        });

        this.fetchData();
    }

    componentWillUnmount() {
        this.socket.disconnect();
    }

    fetchData = async () => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/matrimonypackages`);
            console.log(response.data.data)
            if (response.data) {
                this.setState({ categoryData: response?.data?.data });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    handlegenderChange(e) {
        this.setState({ gender: e.target.value });
    }
    handlemanglikChange = (e) => {
        const value = e.target.value === 'true'; // Convert string value to boolean
        this.setState({
            manglikCheck: e.target.value, // Update radio button selection
            manglik: value, // Update manglik state based on radio button selection
            amanglik: !value, // Update amanglik state based on radio button selection
        });
    };




    handleNativeOfChange = (e) => {
        const nativeOf = e.target.value;
        this.setState({ nativeOf, district: "", homeCity: "" });
    };

    handleDistrictChange = (e) => {
        const district = e.target.value;
        this.setState({ district, homeCity: "" });
    };

    handleCityChange = (e) => {
        const homeCity = e.target.value;
        this.setState({ homeCity });
    };

    handleCasteChange = (e) => {
        const caste = e.target.value;
        this.setState({ caste });
    };
    handleperAnnumChange = (e) => {
        const perAnnum = e.target.value;
        this.setState({ perAnnum });
    }
    handleSateChange = (e) => {
        const state = e.target.value;
        this.setState({ state });
    }




    handleChange = (e) => {
        const files = Array.from(e.target.files);
        const errors = [];

        files.forEach((file) => {
            if (file.size > this.state.maxSize) {
                errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
            } else {
                this.setState({
                    textInput: file,
                    currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
                });
            }
        });

        this.setState({ errors });
    };

    handleChangeMultipleImages = (e) => {
        const files = Array.from(e.target.files);
        const errors = [];
    
        const selectedImages = files.filter((file) => {
            const isValidSize = file.size <= this.state.maxSize;
            if (!isValidSize) {
                errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
            }
            return isValidSize;
        });
    
        this.setState({
            imageInput: selectedImages,
            currentImageUrls: selectedImages.map((file) => URL.createObjectURL(file)),
            errors,
        });
    };
    
    getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        let month = now.getMonth() + 1;
        let day = now.getDate();

        // Add leading zero if month or day is single digit
        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }

        return `${year}-${month}-${day}`;
    };
    handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const {
                imageInput,
                textInput,

                emailInput,
                areaInput,
                about,
                userName,
                fullName,
                fathersName,
                state,
                city,
                pinCode,
                bloodGroup,
                gender,
                manglikCheck,



                expectation,
                height,
                kulName,
                caste,
                perAnnum,
                gotra,
                education,
                firmName,
                firmAddress,
                martitalStatus,
                profession,
                bodyColor,
                mobileNo,
                fathersContact,
                noOfBrothers,
                noOfSister,
                website,
                category,

                dateInput,
                birthTime,
            } = this.state;

            const formData = new FormData();

            // Append single image to FormData object
           
            this.state.imageInput.forEach((file) => {
                formData.append('images', file);
            });
            
            formData.append('address', areaInput);
            formData.append('about', about);
            formData.append('city', city);
            formData.append('userName', userName);
            formData.append('fullName', fullName);
            formData.append('fathersName', fathersName);
            formData.append('gotra', gotra);
            formData.append('education', education);
            formData.append('state', state);
            formData.append('dateOfBirth', dateInput);
            formData.append('birthTime', birthTime);
            formData.append('pincode', pinCode);
            formData.append('bloodGroup', bloodGroup);
            formData.append('gender', gender);
            formData.append('manglik', this.state.manglikCheck);

            // formData.append('expectation', expectation);
            formData.append('height', height);

            formData.append('subcaste', caste);
            formData.append('perAnnum', perAnnum);
            formData.append('packageName', category);
            formData.append('maritalStatus', martitalStatus);
            formData.append('profession', profession);
            formData.append('bodyColor', bodyColor);
            formData.append('mobileNo', mobileNo);
            formData.append('fatherMobile', fathersContact);
            formData.append('numOfBrothers', noOfBrothers);
            formData.append('numOfSisters', noOfSister);

            const token = localStorage.getItem('token');

            // Set token in request headers
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            };

            // Make POST request with headers
            const response = await axios.post("https://samaj.aasmo.in/api/admin/matrimony", formData, config);
            if (response && response.status === 201) {
                this.setState({ submissionStatus: 'success' });
                // this.socket.emit('newJobAdded', { message: 'A new job has been added!' });
                // console.log('newJobAdded', { message: 'A new job has been added!' });

                setTimeout(() => {
                this.props.history.push("/matrimonylist");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
        }
    };

    render() {
        const { textInput, imageInput, category, categoryData, currentImageUrl, refCode, emailInput, areaInput, submeet, about, fullName, fathersName, userName, state, city, pinCode, bloodGroup, nativeOf, district, kulName, caste, perAnnum, subcaste, gotra, education, firmName, firmAddress, martitalStatus, profession, bodyColor, mobileNo, fathersContact, noOfBrothers, noOfSister, website, gender, manglik, homeCity, expectation, height, dateInput, birthTime, submissionStatus, manglikCheck
        } = this.state;
        const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Add Matrimony</h2>
                    </div>
                    <div className="body">
                        <form className="ng-untouched ng-dirty ng-invalid">
                            <div className="form-group">
                                <label>UserName</label>
                                <input
                                    className={`form-control ${!reg.test(userName) && submeet && "parsley-error"
                                        }`}
                                    value={userName}
                                    name="userName"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ userName: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(userName) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Full Name</label>
                                <input
                                    className={`form-control ${!reg.test(userName) && submeet && "parsley-error"
                                        }`}
                                    value={fullName}
                                    name="fullName"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ fullName: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(fullName) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Father's Name</label>
                                <input
                                    className={`form-control ${!reg.test(userName) && submeet && "parsley-error"
                                        }`}
                                    value={fathersName}
                                    name="fathersName"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ fathersName: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(fathersName) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Gender</label>
                                <br />
                                <label className="fancy-radio">
                                    <input
                                        data-parsley-errors-container="#error-radio"
                                        name="gender"
                                        required=""
                                        type="radio"
                                        value="Male"
                                        onChange={this.handlegenderChange} // Add onChange event
                                        checked={gender === 'Male'} // Add checked attribute
                                    />
                                    <span>
                                        <i></i>Male
                                    </span>
                                </label>
                                <label className="fancy-radio">
                                    <input
                                        name="gender"
                                        type="radio"
                                        value="Female"
                                        onChange={this.handlegenderChange} // Add onChange event
                                        checked={gender === 'Female'} // Add checked attribute
                                    />
                                    <span>
                                        <i></i>Female
                                    </span>
                                </label>
                                <label className="fancy-radio">
                                    <input
                                        name="gender"
                                        type="radio"
                                        value="Other"
                                        onChange={this.handlegenderChange} // Add onChange event
                                        checked={gender === 'Other'} // Add checked attribute
                                    />
                                    <span>
                                        <i></i>Other
                                    </span>
                                </label>
                            </div>
                            <div className="form-group">
                                <label htmlFor="martitalStatus">Marital Status</label>
                                <select
                                    className={`form-control ${submeet && !martitalStatus && "parsley-error"
                                        }`}
                                    value={martitalStatus}
                                    name="martitalStatus"
                                    // required=""
                                    onChange={(e) => {
                                        this.setState({ martitalStatus: e.target.value });
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="Single">Single</option>
                                    <option value="Married">Married</option>
                                    <option value="Divorced">Divorced</option>
                                    <option value="Widowed">Widowed</option>

                                </select>
                                {/* {submeet && !martitalStatus ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Deals With is required.</li>
                  </ul>
                ) : null} */}
                            </div>
                            <div className="form-group">
                                <label>Father's Contact No </label>
                                <input
                                    className={`form-control ${!reg.test(fathersContact) && submeet && "parsley-error"
                                        }`}
                                    value={fathersContact}
                                    name="fathersContact"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    // required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ fathersContact: e.target.value });
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                <label>No. Of Brother's </label>
                                <input
                                    className={`form-control ${!reg.test(noOfBrothers) && submeet && "parsley-error"
                                        }`}
                                    value={noOfBrothers}
                                    name="noOfBrothers"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    // required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ noOfBrothers: e.target.value });
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                <label>No. Of Sister's </label>
                                <input
                                    className={`form-control ${!reg.test(noOfSister) && submeet && "parsley-error"
                                        }`}
                                    value={noOfSister}
                                    name="noOfSister"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    // required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ noOfSister: e.target.value });
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                <label>Manglik</label>
                                <br />
                                <label className="fancy-radio">
                                    <input
                                        data-parsley-errors-container="#error-radio"
                                        name="manglikCheck"
                                        required=""
                                        type="radio"
                                        value="true"
                                        onChange={this.handlemanglikChange}
                                        checked={manglikCheck === 'true'}
                                    />
                                    <span>
                                        <i></i>Manglik
                                    </span>
                                </label>
                                <label className="fancy-radio">
                                    <input
                                        name="manglikCheck"
                                        type="radio"
                                        value="false"
                                        onChange={this.handlemanglikChange}
                                        checked={manglikCheck === 'false'}
                                    />
                                    <span>
                                        <i></i>Non-Manglik
                                    </span>
                                </label>
                            </div>

                            <div className="form-group">
                                <label htmlFor="bodyColor">Body Colour</label>
                                <select
                                    className={`form-control ${submeet && !bodyColor && "parsley-error"
                                        }`}
                                    value={bodyColor}
                                    name="bodyColor"
                                    // required=""
                                    onChange={(e) => {
                                        this.setState({ bodyColor: e.target.value });
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="Fair">Fair</option>
                                    <option value="Wheatish">Wheatish</option>
                                    <option value="Dusky">Dusky</option>
                                    <option value="Black">Black</option>

                                </select>
                                {/* {submeet && !bodyColor ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Deals With is required.</li>
                  </ul>
                ) : null} */}
                            </div>
                            <div className="form-group">
                                <label>Height</label>
                                <input
                                    className={`form-control ${!reg.test(height) && submeet && "parsley-error"
                                        }`}
                                    value={height}
                                    name="height"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ height: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(height) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="bloodGroup">Blood Group</label>
                                <select
                                    className={`form-control ${submeet && !bloodGroup && "parsley-error"
                                        }`}
                                    value={bloodGroup}
                                    name="bloodGroup"
                                    required=""
                                    onChange={(e) => {
                                        this.setState({ bloodGroup: e.target.value });
                                    }}
                                >
                                    <option value="">Select Blood Group</option>
                                    <option value="A+">A+</option>
                                    <option value="A-">A-</option>
                                    <option value="B+">B+</option>
                                    <option value="B-">B-</option>
                                    <option value="AB+">AB+</option>
                                    <option value="AB-">AB-</option>
                                    <option value="O+">O+</option>
                                    <option value="O-">O-</option>
                                </select>
                                {submeet && !bloodGroup ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">Blood group is required.</li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Date Of Birth</label>
                                <input
                                    className={`form-control ${!reg.test(dateInput) && submeet && "parsley-error"}`}
                                    value={dateInput}
                                    name="dateInput"
                                    // Assuming you want to validate date format
                                    pattern="\d{4}-\d{2}-\d{2}" // Date format validation pattern
                                    type="date" // Change type to "date"
                                    max={this.getCurrentDate} // Limit the max date to the current date
                                    onChange={(e) => {
                                        this.setState({ dateInput: e.target.value });
                                    }}
                                />
                                {/* Optional: Add error message for invalid format */}
                                {/* {submeet && !reg.test(dateInput) ? (
        <ul className="parsley-errors-list filled" id="parsley-id-29">
            <li className="parsley-required">
                Please enter a valid date in YYYY-MM-DD format.
            </li>
        </ul>
    ) : null} */}
                            </div>

                            <div className="form-group">
                                <label>Birth Time</label>
                                <input
                                    className={`form-control ${!reg.test(birthTime) && submeet && "parsley-error"
                                        }`}
                                    value={birthTime}
                                    name="birthTime"
                                    // Assuming you want to validate date format
                                    pattern="\d{4}-\d{2}-\d{2}" // Date format validation pattern
                                    type="birthTime" // Change type to "date"
                                    onChange={(e) => {
                                        this.setState({ birthTime: e.target.value });
                                    }}
                                />
                                {/* {submeet && !reg.test(dateInput) ? (
      <ul className="parsley-errors-list filled" id="parsley-id-29">
        <li className="parsley-required">
          This value is required.
        </li>
      </ul>
    ) : null} */}
                            </div>
                            <div className="form-group">
                                <label>Address</label>
                                <textarea
                                    className={`form-control ${areaInput === "" && submeet && "parsley-error"
                                        }`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ areaInput: e.target.value });
                                    }}
                                ></textarea>
                                {areaInput === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>mobileNo No </label>
                                <input
                                    className={`form-control ${!reg.test(mobileNo) && submeet && "parsley-error"
                                        }`}
                                    value={mobileNo}
                                    name="mobileNo"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    // required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ mobileNo: e.target.value });
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                <label>Education</label>
                                <input
                                    className={`form-control ${!reg.test(education) && submeet && "parsley-error"
                                        }`}
                                    value={education}
                                    name="education"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ education: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(education) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Sub Caste</label>
                                <select
                                    className="form-control"
                                    value={caste}
                                    name="caste"
                                    onChange={this.handleCasteChange}
                                >
                                    <option value="">Select Sub Caste</option>
                                    <option value="Kurmi">Kurmi</option>
                                    <option value="Patel">Patel</option>
                                    <option value="General">General</option>
                                    <option value="Other">Other</option>
                                    {/* Add more options for caste */}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="profession">Profession</label>
                                <select
                                    className={`form-control ${submeet && !profession && "parsley-error"
                                        }`}
                                    value={profession}
                                    name="profession"
                                    // required=""
                                    onChange={(e) => {
                                        this.setState({ profession: e.target.value });
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="Doctor">Doctor</option>
                                    <option value="SoftwareEngineer">Software Engineer</option>
                                    <option value="GovernmentEmployee">Government Employee</option>
                                    <option value="Other">Other</option>

                                </select>
                                {/* {submeet && !profession ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Deals With is required.</li>
                  </ul>
                ) : null} */}
                            </div>
                            {/* <div className="form-group">
                                <label>Expectation</label>
                                <input
                                    className={`form-control ${!reg.test(expectation) && submeet && "parsley-error"
                                        }`}
                                    value={expectation}
                                    name="expectation"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ expectation: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(expectation) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div> */}
                            <div className="form-group">
                                <label>Per Annum</label>
                                <select
                                    className="form-control"
                                    value={perAnnum}
                                    name="perAnnum"
                                    onChange={this.handleperAnnumChange}
                                >
                                    <option value="">Select Income</option>
                                    <option value="lessthan3lac">Less than 3 lac</option>
                                    <option value="3lacto10lac">3lac-10lac</option>
                                    <option value="10lacto50lac">10lac-50lac</option>
                                    <option value="morethan50lac">More than 50lac</option>
                                    {/* Add more options for caste */}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Gotra</label>
                                <input
                                    className={`form-control ${!reg.test(gotra) && submeet && "parsley-error"
                                        }`}
                                    value={gotra}
                                    name="gotra"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ gotra: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(gotra) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
    <label>Images</label>
    
    <div>
        {this.state.currentImageUrls.map((url, index) => (
            <img 
                key={index}
                src={url} 
                alt={`Preview ${index}`} 
                style={{ width: '100px', marginBottom: '10px', marginRight: '10px' }} 
            />
        ))}
    </div>
    
    <input
        type="file"
        className={`form-control ${!this.state.imageInput.length && this.state.submeet && "parsley-error"}`}
        name="imageInput"
        required=""
        multiple
        onChange={this.handleChangeMultipleImages}
    />
    {!this.state.imageInput.length && this.state.submeet ? (
        <ul className="parsley-errors-list filled">
            <li className="parsley-required">This value is required.</li>
        </ul>
    ) : null}
</div>


                            <div className="form-group">
                                <label>City</label>
                                <input
                                    className={`form-control ${!reg.test(city) && submeet && "parsley-error"
                                        }`}
                                    value={city}
                                    name="city"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ city: e.target.value });
                                    }}
                                />
                                {submeet && !reg.test(city) ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>State</label>
                                <select
                                    className="form-control"
                                    value={state}
                                    name="state"
                                    onChange={this.handleSateChange}
                                >
                                    <option value="">Select State</option>
                                    <option value="MadhyaPradesh">Madhya Pradesh</option>
                                    <option value="Meghalaya">Meghalaya</option>
                                    <option value="Kerela">Kerela</option>
                                    <option value="Punjab">Punjab</option>
                                    {/* Add more options for caste */}
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Pincode</label>
                                <input
                                    type="number"
                                    className={`form-control ${textInput === "" && submeet && "parsley-error"
                                        }`}
                                    value={pinCode}
                                    name="number"
                                    required=""
                                    onChange={(e) => {
                                        this.setState({
                                            pinCode: e.target.value,
                                            submeet: false,
                                        });
                                    }}
                                />
                                {pinCode === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>About</label>
                                <textarea
                                    className={`form-control ${about === "" && submeet && "parsley-error"
                                        }`}
                                    value={about}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ about: e.target.value });
                                    }}
                                ></textarea>
                                {about === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label htmlFor="bloodGroup">Select Packages</label>
                                <select
                                    className={`form-control ${submeet && !category && "parsley-error"
                                        }`}
                                    value={category}
                                    name="category"
                                    required=""
                                    onChange={(e) => {
                                        this.setState({ category: e.target.value });
                                    }}
                                >
                                    <option value="">Select Packages</option>
                                    {categoryData && categoryData.map((key) => (
                                        <option key={key.id} value={key._id}>{key.title}</option>
                                    ))}
                                </select>
                                {submeet && !category ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">Category is required.</li>
                                    </ul>
                                ) : null}
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <br />
                        </form>
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                // this.setState({ submeet: true });
                                this.handleSubmit(e)
                            }}
                        >
                            Submit
                        </button>

                    </div>
                </div>


            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, {})(AddMatrimony));
